import { CHANAKYA_COLORS, THEME_ACCENT_COLORS } from '../chanakyaColors';

const SIZE = 1080;

const THEME_LABELS_EN = {
  business: 'Business', relationships: 'Relationships', governance: 'Governance',
  self_discipline: 'Self-Discipline', strategy: 'Strategy', ethics: 'Ethics',
};

const THEME_LABELS_TA = {
  business: 'வணிகம்', relationships: 'உறவுகள்', governance: 'ஆட்சி',
  self_discipline: 'சுய ஒழுக்கம்', strategy: 'யுத்தி', ethics: 'நீதி',
};

function wrapText(ctx, text, maxWidth) {
  const words = text.split(/\s+/);
  const lines = [];
  let current = '';
  for (const w of words) {
    const candidate = current ? `${current} ${w}` : w;
    if (ctx.measureText(candidate).width > maxWidth && current) {
      lines.push(current);
      current = w;
    } else {
      current = candidate;
    }
  }
  if (current) lines.push(current);
  return lines;
}

async function renderCanvas(reading, lang) {
  const canvas = document.createElement('canvas');
  canvas.width = SIZE;
  canvas.height = SIZE;
  const ctx = canvas.getContext('2d');

  const bg = ctx.createLinearGradient(0, 0, 0, SIZE);
  bg.addColorStop(0, CHANAKYA_COLORS.parchment);
  bg.addColorStop(1, '#E8DCC0');
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, SIZE, SIZE);

  ctx.strokeStyle = CHANAKYA_COLORS.accent;
  ctx.lineWidth = 6;
  ctx.strokeRect(40, 40, SIZE - 80, SIZE - 80);
  ctx.strokeStyle = CHANAKYA_COLORS.primary;
  ctx.lineWidth = 2;
  ctx.strokeRect(56, 56, SIZE - 112, SIZE - 112);

  ctx.textAlign = 'center';
  ctx.fillStyle = CHANAKYA_COLORS.primaryDark;
  ctx.font = '600 44px "Noto Sans Tamil", "Playfair Display", serif';
  ctx.fillText("Chanakya's Counsel", SIZE / 2, 150);

  const themeLabel = lang === 'ta' ? THEME_LABELS_TA[reading.theme] : THEME_LABELS_EN[reading.theme];
  const accent = THEME_ACCENT_COLORS[reading.theme] || CHANAKYA_COLORS.accent;
  ctx.fillStyle = accent;
  ctx.font = '500 22px "Noto Sans Tamil", sans-serif';
  ctx.fillText(themeLabel, SIZE / 2, 200);

  ctx.fillStyle = CHANAKYA_COLORS.accentDark;
  ctx.font = '500 24px "Noto Sans Tamil", sans-serif';
  ctx.fillText(`Aphorism ${reading.cell}`, SIZE / 2, 240);

  ctx.fillStyle = '#2C1810';
  ctx.font = '500 30px "Noto Sans Devanagari", serif';
  const devLines = wrapText(ctx, reading.shloka_sa, SIZE - 180);
  let y = 320;
  devLines.forEach(line => { ctx.fillText(line, SIZE / 2, y); y += 44; });

  ctx.font = '400 24px "Noto Sans Tamil", sans-serif';
  ctx.fillStyle = CHANAKYA_COLORS.textSecondary;
  const taLines = wrapText(ctx, reading.translation_ta, SIZE - 200);
  y += 24;
  taLines.forEach(line => { ctx.fillText(line, SIZE / 2, y); y += 36; });

  const interp = lang === 'ta' ? reading.interpretation_ta : reading.interpretation_en;
  ctx.font = '400 26px "Noto Sans Tamil", sans-serif';
  ctx.fillStyle = '#2C1810';
  const iLines = wrapText(ctx, interp, SIZE - 220);
  y += 36;
  iLines.forEach(line => { ctx.fillText(line, SIZE / 2, y); y += 38; });

  ctx.font = '400 20px "Noto Sans Tamil", sans-serif';
  ctx.fillStyle = CHANAKYA_COLORS.primaryDark;
  ctx.fillText('via JyotishSastra', SIZE / 2, SIZE - 70);

  const dataUrl = canvas.toDataURL('image/png');
  const blob = await new Promise(r => canvas.toBlob(r, 'image/png'));
  return { dataUrl, blob };
}

export default async function chanakyaShareImageRenderer(reading, lang) {
  return renderCanvas(reading, lang);
}
